<div class="sticky-player__chrome">
  <button
    type="button"
    class="sticky-player__expand"
    (click)="expand.emit()"
  >
    <span class="sticky-player__label">
      {{ 'app.parentLearning.sticky.nowPlaying' | translate }}
    </span>
    <span class="sticky-player__title">{{ lessonTitle() }}</span>
    <span class="sticky-player__action">
      {{ 'app.parentLearning.sticky.expand' | translate }}
    </span>
  </button>
</div>
